import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../service/security/security.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  user : any;
  constructor(private router: Router,private loginService:SecurityService ) { 
    
    this.user = JSON.parse(sessionStorage.getItem("UserActive"));
    this.validarToken();

  }

  ngOnInit() {
  }

  
  validarToken(){

    try {
        
        let rep = /5Sfg2IvaFl91jbF/gi;
        let rep2 = /G3SIvaFsj23D/gi;

        let TOKEN = this.loginService.TOKEN;
        // console.log('TOKEN', TOKEN)
        let TOKEN2 =  sessionStorage.getItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55');
        // console.log('TOKEN2', TOKEN2)
        // console.log('TOKEN2', TOKEN2)
         let array = TOKEN2.split("ñ",18);
        //  console.log('array', array)


        for (let index = 0, i = 16; index < array.length; index++ , i--) {
            if (array[index] != array[i]){
                this.router.navigate(['/login']);
            }
        }


    } catch (error) {
        this.router.navigate(['/login']);
    } 
  }
}
